import { render, staticRenderFns } from "./VerticalTabs.vue?vue&type=template&id=7d0a5858"
import script from "./VerticalTabs.vue?vue&type=script&lang=js"
export * from "./VerticalTabs.vue?vue&type=script&lang=js"
import style0 from "./VerticalTabs.vue?vue&type=style&index=0&id=7d0a5858&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports